import { Link, useLocation } from "react-router-dom";

function isExternalHref(href) {
  return href.startsWith("http://") || href.startsWith("https://") || href.startsWith("mailto:");
}

export default function SmartLink({ href, external, children, onClick, ...props }) {
  const location = useLocation();

  if (external || isExternalHref(href)) {
    return (
      <a href={href} target="_blank" rel="noopener noreferrer" onClick={onClick} {...props}>
        {children}
      </a>
    );
  }

  const [targetPathname, targetHash = ""] = href.split("#");
  const normalizedPathname = targetPathname || location.pathname;

  const handleClick = (event) => {
    onClick?.(event);

    if (event.defaultPrevented) {
      return;
    }

    if (location.pathname === normalizedPathname && targetHash) {
      const targetElement = document.getElementById(targetHash);

      if (targetElement) {
        event.preventDefault();
        window.history.pushState(null, "", `#${targetHash}`);
        targetElement.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }

    if (location.pathname === normalizedPathname && !targetHash) {
      event.preventDefault();
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    }
  };

  return (
    <Link to={href} onClick={handleClick} {...props}>
      {children}
    </Link>
  );
}
